import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedSpecialServiceRequest = () => {
  return {
    category: {},
    permiFree: false,
    cabinClasses: [],
    multiplier: false,
    detail: { limitless: false },
    prices: [],
    stationRestrictions: [],
    active: false,
    saleChannels: [],
    trainTypes: [],
  };
};

export default {
  state: () => ({
    selectedSpecialServiceRequest: getDefaultSelectedSpecialServiceRequest(),
  }),

  mutations: {
    setSelectedSpecialServiceRequest(state, specialServiceRequest) {
      Vue.set(state, "selectedSpecialServiceRequest", specialServiceRequest);
    },
    setDefaultSelectedSpecialServiceRequest(state) {
      Vue.set(state, "selectedSpecialServiceRequest", getDefaultSelectedSpecialServiceRequest());
    },
  },
  actions: {
    //TODO: load, update, create
    createSpecialServiceRequest: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/special-service-request/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadSpecialServiceRequests: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request/entity").then((response) => {
        return response.data;
      });
    },
    loadPublishedSpecialServiceRequests: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getTmsCdnServiceUrl + "/special-service-request.json").then((response) => {
        //TODO: Loader koyulacak
        return response.data;
      });
    },
    loadPublishedSpecialServiceRequestsFromTmsCdn: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getTmsCdnServiceUrl + "/special-service-request.json").then((response) => {
        //TODO: Loader koyulacak
        return response.data;
      });
    },
    loadSpecialServiceRequest: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request/entity/" + request.id).then((response) => {
        return response.data;
      });
    },
    loadSpecialServiceRequestHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/special-service-request/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedSpecialServiceRequestHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteSpecialServiceRequest: (context, specialServiceRequest) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/special-service-request/entity/" + specialServiceRequest.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          specialServiceRequest.intents = intents;
          specialServiceRequest.intentId = response.data.id;
          return specialServiceRequest;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftSpecialServiceRequest: (context, specialServiceRequest) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/special-service-request/draft/" + specialServiceRequest.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishSpecialServiceRequest: (context, specialServiceRequest) => {
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request/publish/" + specialServiceRequest.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectSpecialServiceRequest: (context, specialServiceRequest) => {
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request/reject/" + specialServiceRequest.intentId).then((response) => {
        if (specialServiceRequest.intents[0].type === "DELETE_SPECIAL_SERVICE_REQUEST") {
          specialServiceRequest.intents = null;
          specialServiceRequest.intentId = 0;
        } else if (specialServiceRequest.intents[0].type === "CREATE_SPECIAL_SERVICE_REQUEST") {
          specialServiceRequest.intents[0].status = "DRAFT";
        } else if (specialServiceRequest.intents[0].type === "UPDATE_SPECIAL_SERVICE_REQUEST") {
          specialServiceRequest.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalSpecialServiceRequest: (context, specialServiceRequest) => {
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request/sendToApproval/" + specialServiceRequest.intentId).then((response) => {
        if (specialServiceRequest.intents[0].type === "CREATE_SPECIAL_SERVICE_REQUEST") {
          specialServiceRequest.intents[0].status = "WAITING_APPROVAL";
        } else if (specialServiceRequest.intents[0].type === "UPDATE_SPECIAL_SERVICE_REQUEST") {
          specialServiceRequest.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallSpecialServiceRequest: (context, specialServiceRequest) => {
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request/recall/" + specialServiceRequest.intentId).then((response) => {
        helper.recallOrRejectEntity(specialServiceRequest, "SPECIAL_SERVICE_REQUEST");
        return response.data;
      });
    },
    cancelSpecialServiceRequest: (context, specialServiceRequest) => {
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request/cancel/" + specialServiceRequest.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedSpecialServiceRequest: (state) => {
      return state.selectedSpecialServiceRequest;
    },
  },
};
